<template>
  <div class="container">
    <br />
    <br />
    <br />
    <v-layout row wrap>
      <!-- <v-flex xs12 sm12 md6 lg1></v-flex> -->
      <v-flex xs6 sm6 md6 lg6>
        <div class="habit-btn">
          <v-btn to="/CargarPlagas" large block width class="humedad" dark>
            <!-- <v-icon class="icon">mdi-pen</v-icon>
            Subir datos -->
            <img src="../assets/Upload.png" class="png" />
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs6 sm6 md6 lg6>
        <div class="habit-btn">
          <v-btn to="/ReportesPlagas" large block class="ce" dark>
            <!-- <v-icon class="icon">mdi-book-open</v-icon>
            Reportes -->
            <img src="../assets/Reports.png" class="png" />
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  created() {},

  beforeMount() {
    console.log("ID", this.$store.state.companyId);
    this.$store.dispatch("getProjectsArr", this.$store.state.companyId);
  },
};
</script>

<style scoped>
.container {
  height: 100% !important;
  zoom: 100% !important;
}

.habit-btn {
  margin-left: 15%;
  height: 50% !important;
}

.png {
  width: 40%;
  border-radius: 15px !important;
}

.humedad {
  background-color: rgb(155, 197, 109) !important;
  padding-top: 130px !important;
  padding-bottom: 130px !important;
}

.humedad:hover {
  opacity: 0.5;
}

.ce {
  background-color: rgb(77, 107, 72) !important;
  padding-top: 130px !important;
  padding-bottom: 130px !important;
}
.ce:hover {
  opacity: 0.5;
}

.ph {
  background-color: rgb(89, 147, 108) !important;
  padding-top: 130px !important;
  padding-bottom: 130px !important;
}

.ph:hover {
  opacity: 0.5;
}

.plagas {
  background-color: rgb(76, 117, 98) !important;
  padding-top: 130px !important;
  padding-bottom: 130px !important;
  opacity: 0.7;
  /* cursor: no-drop; */
}

.polinizacion {
  background-color: rgb(56, 101, 104) !important;
  padding-top: 130px !important;
  padding-bottom: 130px !important;
  opacity: 0.7;
  cursor: no-drop;
}

@media only screen and (max-width: 600px) {
  .container {
    width: 95% !important;
    height: 60% !important;
    zoom: 35% !important;
    margin-left: 0 !important;
    margin-top: 45px !important;
  }
}
</style>
